import { api } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDeletePerson() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => {
      if (id) {
        return api.delete(`people/${id}`);
      }
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['people'] }),
  });
}
